/**
 * 줌에 따른 실루엣 ↔ 타일 교차 페이드.
 *
 * 전국 지도(흰 실루엣)와 현장 지도(타일)를 **한 인스턴스**로 합치기 위한 장치다.
 * 예전에는 둘이 다른 지도라 화면을 옮길 때 지도를 새로 만들어야 했고, 그래서 줌인
 * 연출이 불가능했다. 같은 지도에 두 레이어를 얹고 줌으로 갈아끼우면 전국 → 현장이
 * 한 번의 `flyTo` 로 이어진다.
 *
 * 경계를 계단이 아니라 구간으로 둔 이유는, 손으로 줌할 때 특정 배율에서 화면이
 * 툭 바뀌면 고장으로 읽히기 때문이다.
 */

/** 이 배율 아래는 실루엣만. 국토 전체가 보이는 구간이다. */
export const SILHOUETTE_Z = 8;
/** 이 배율 위는 타일만. 현장 부지가 보이기 시작하는 구간이다. */
export const TILE_Z = 10.5;

/** 전국 보기로 되돌아갈 때 쓰는 배율. */
export const NATIONAL_Z = 7;
/** 현장으로 들어갈 때의 배율. */
export const SITE_Z = 17;

/** 0 = 실루엣만, 1 = 타일만. 그 사이는 선형으로 섞인다. */
export function tileOpacityAt(zoom: number): number {
  if (zoom <= SILHOUETTE_Z) return 0;
  if (zoom >= TILE_Z) return 1;
  return (zoom - SILHOUETTE_Z) / (TILE_Z - SILHOUETTE_Z);
}

/**
 * 실루엣 쪽 불투명도.
 *
 * 타일의 여집합(1 - t)이 아니라 더 빨리 사라지게 한다. 둘 다 반쯤 보이는 구간에서
 * 흰 실루엣이 타일 위에 덮여 색이 바래 보이기 때문이다.
 */
export function silhouetteOpacityAt(zoom: number): number {
  return Math.max(0, 1 - tileOpacityAt(zoom) * 1.6);
}
